var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"nav col-lg-4"},[_c('Menu')],1),_c('div',{staticClass:"col-lg-8 content col-sm-12"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }